var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row py-5"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"text-center no-results"},[_c('div',{staticClass:"fa fa-search"}),_vm._v(" "+_vm._s(_vm.text)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }